import { createElement } from '../../utils/utils';
export const Text = props => {
  const {
    title = false,
    text,
    subtitle = false
  } = props;
  let element;
  if (title) {
    element = createElement({
      tagName: 'h2',
      ...props
    });
  } else if (subtitle) {
    element = createElement({
      tagName: 'h3',
      ...props
    });
  } else {
    element = createElement({
      tagName: 'p',
      ...props
    });
  }
  element.innerText = text;
  return element;
};
//# sourceMappingURL=text.js.map